import {Rol} from "../../../roles/recursos/modelo/rol";
import {Emisor} from "../../../emisor/recursos/modelo/emisor";


export class Usuario {
    public id: number;
    public cedula: string;
    public nombres: string;
    public apellidos: string;
    public password: string;
    public password_2: string;
    public customer: any;
    public username: string;
    public correo: string;
    public foto: string;
    public nombreFoto: string;
    public direccion: string;
    public telefonoPrincipal: string;
    public telefonoSecundario: string;
    public fechaUltimoIngreso: string;
    public fechaCaducidadClave: string;
    public rol: any;
    public logEstatusRegistro: string;
    public logUsernameRegistro: string;
    public logFechaRegistro: string;
    public logUsernameModificacion: string;
    public logFechaModificacion: string;
    public origen: string;
    public lstFuncionalidades: any[];
    public authorities: any[];
    public pdfDocumentTemplate: any;

    constructor(id: number = null,
                cedula: string = "",
                nombre: string = "",
                apellido: string = "",
                emisor: any = new Emisor(),
                username: string = "",
                correo: string = "",
                foto: string = null,
                direccion: string = "",
                telefonoPrincipal: string = null,
                telefonoSecundario: string = null,
                fechaUltimoIngreso: string = null,
                fechaCaducidadClave: string = null,
                rol: any = new Rol(null),
                logEstatusRegistro: string = "ACTIVO",
                logUsernameRegistro: string = "",
                logFechaRegistro: string = null,
                logUsernameModificacion: string = "",
                logFechaModificacion: string = null,
                origen: string = "",
                pdfDocumentTemplate: any = {},
                funcionalidad?: any[],
                authorities?: any[]
    ) {

        this.id = id;
        this.nombres = nombre;
        this.apellidos = apellido;
        this.cedula = cedula;
        this.username = username;
        this.correo = correo;
        this.customer = emisor;
        this.foto = foto;
        this.nombreFoto = null;
        this.direccion = direccion;
        this.telefonoPrincipal = telefonoPrincipal;
        this.telefonoSecundario = telefonoSecundario;
        this.fechaUltimoIngreso = fechaUltimoIngreso;
        this.fechaCaducidadClave = fechaCaducidadClave;
        this.rol = rol;
        this.origen = origen;
        this.lstFuncionalidades = funcionalidad;
        this.authorities = authorities;
        this.pdfDocumentTemplate = pdfDocumentTemplate;
        // CAMPOS DE AUDITORIA
        this.logEstatusRegistro = logEstatusRegistro;
        this.logUsernameRegistro = logUsernameRegistro;
        this.logFechaRegistro = logFechaRegistro;
        this.logUsernameModificacion = logUsernameModificacion;
        this.logFechaModificacion = logFechaModificacion;
    }
}


// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/usuario/recursos/modelo/usuario.ts